/* eslint-disable @typescript-eslint/no-explicit-any */
import IntroductionCover from './Cover'
import IntroductionEntry from './Entry'
import IntroductionSections from './Sections'

type TopicTheme = {
  light: string
  background: string
  dark: string
  promoted: string
  illustration: { aspect: number; path: string; webp: string }
}

type Section = {
  _key: string
  title: string
  text: any[]
  asset: any
}

export { IntroductionCover, IntroductionEntry, IntroductionSections, type Section, type TopicTheme }
